import { CHAT_BLOCKED, TOGGLE_CHAT } from 'actions/chatAction';

import update from 'helpers/Immutability';

const chat = (state = {}, action) => {
    let mergeState;
    switch (action.type) {
        case CHAT_BLOCKED:
            mergeState = update(state, {
                $auto: {
                    chatBlocked: { $set: action.chatBlocked },
                },
            });
            break;
        case TOGGLE_CHAT:
            mergeState = update(state, {
                $auto: {
                    chatIsOpen: { $set: action.chatIsOpen },
                },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default chat;
